// [Phase 3(c) Sub-stage 2, deliverable 2 / STOP-C:C1] Minimal real Settings page,
// replacing the placeholder. Hosts ONLY the editable "Ley 40 applicability" gate
// section (reusing Ley40GateQuestionnaire — the same component as the post-auth
// registration step). A full settings surface is a future item, noted inline.
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { SlidersHorizontal } from 'lucide-react';
import { useTranslation } from '@/i18n/TranslationContext';
import Ley40GateQuestionnaire from '@/components/Ley40GateQuestionnaire';

export default function SettingsPage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-6 animate-fade-in" data-testid="settings-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground">{t('nav_settings')}</h1>
        <p className="text-sm text-muted-foreground mt-1">{t('settings_future_note')}</p>
      </div>
      <Card className="max-w-2xl">
        <CardHeader className="pb-3">
          <CardTitle className="text-base font-semibold flex items-center gap-2">
            <SlidersHorizontal className="h-4 w-4 text-primary" />{t('settings_ley40_section')}
          </CardTitle>
          <CardDescription>{t('gate_intro')}</CardDescription>
        </CardHeader>
        <CardContent>
          {/* Pre-populated per the legacy mapping server-side (02/03; 01/04/05 = Not
              yet answered). Editing writes an append-only scope_evaluations record. */}
          <Ley40GateQuestionnaire />
        </CardContent>
      </Card>
    </div>
  );
}
